



































































































































import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/firestore'
import * as Interface from '../../functions/interfaces'


export default Vue.extend({
    mounted() {
        this.fetch(undefined)
    },


    beforeRouteUpdate(to, from, next) {
        this.fetch(to.params.id)
        next()
    },


    computed: {
        editor_config: function() {
            return {
                placeholder: this.$t('description'),
                hideIcons: ['fullscreen', 'side-by-side', 'guide'],
                spellChecker: false,
                status: false
            }
        },
    },


    data() {
        return {
            language: 'hu',
            loading: false,
            error: null,
            project: {
                name: {},
                alias: {},
                description: {},
                target: 0,
                currency: 'HUF',
                pledged: 0,
                backers: 0,
                active: true
            } as Interface.Project
        }
    },


    methods: {
        changeAlias() {
            let alias = this.project.name[this.language].replace(/[^a-zA-Z0-9]/g, '')
            alias = alias.toLowerCase()
            Vue.set(this.project.alias, this.language, alias)
        },


        fetch: async function(to: string | undefined) {
            
            // Prepare
            const id = to ?? this.$route.params.id
            if (id == 'new' || id == null) return null

            // Fetch
            try { await firebase.firestore().collection('projects').doc(id).onSnapshot((doc) => {
                const project = doc.data()!
                project.id = doc.id
                const target = project.target.toString()
                project.target = target
                Object.assign(this.project, project)
            })}
            catch(error) { console.log('Unable to fetch event'), error; alert(error.message) }
        },


        toggleActive: async function() {    
            
            // Prepare
            this.loading = true
            const doc = firebase.firestore().collection('projects').doc(this.project.id)
            const active = !this.project.active

            // Upload
            try { await doc.update({active: active}) }
            catch(e) { console.log('Unable to update active state'), e; alert(e.message) }
            finally { this.loading = false }
        },


        isEmpty: function(map) {
            return (Object.values(map).every(v => v == ""))
        },


        save: async function() {

            // Guard
            this.error = null
            if (this.isEmpty(this.project.name)) { this.error = this.$t('missing_name'); return }
            if (this.isEmpty(this.project.alias)) { this.error = this.$t("missing_alias"); return }
            if (this.isEmpty(this.project.description)) { this.error = this.$t("missing_description"); return }
            if (this.project.target == 0) { this.error = this.$t("missing_target"); return }

            
            // Prepare the project
            this.loading = true
            this.$refs.save.innerText = this.$t('saving')
            const project = JSON.parse(JSON.stringify(this.project))
            project.aliases = Object.values(project.alias).map((value) => value)
            project.target = parseInt(project.target.split(' ').join(''))

            // Update if exsists, create if not
            const path = firebase.firestore().collection('projects')
            let doc: firebase.firestore.DocumentReference
            if (project.id) {
                doc = path.doc(project.id)
                delete project.id
            } else {
                doc = path.doc()
                project.date = firebase.firestore.Timestamp.fromDate(new Date())
            }
            
            // Upload
            try { 
                await doc.set(project)
                console.log(this.$refs)
                this.$refs.save.innerText = this.$t('saved')
                setTimeout(() => {
                    this.$refs.save.innerText = this.$t('save')
                }, 3000)}
            catch(e) { console.log('Unable to save event'), e; alert(e.message); this.$refs.save.innerText = this.$t('save') }
            finally { this.loading = false }

            
            // Redirect
            if (this.project.id == null)
                this.$router.push({name: 'edit', params: {'id': doc.id }})
        }
    }
})

